<template>
  <v-container fluid class="pa-0">
    <!-- pdf显示 -->
    <v-card v-if="!bigLoading" tile>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" v-for="(img, idx) in pdfImages" :key="idx">
            <v-img :src="`data:image/jpg;base64,${img}`" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- loading -->
    <v-dialog v-model="bigLoading" persistent max-width="450">
      <v-card min-height="200">
        <v-card-title>
          <v-icon class="mdi-spin mr-2">mdi-timer-sand</v-icon>
          报告加载中, 请耐心等待...
        </v-card-title>
        <v-card-text class="pl-6 pr-6">
          <v-row justify="center">
            <v-col cols="auto">
              <span v-text="bigLoadingTimer" class="text-h1"></span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 报告确认提示内容 -->
    <template v-if="!cf && !bigLoading && isPreviewReport">
      <div
        style="
          top: 0;
          width: 100%;
          position: fixed;
          z-index: 99;
          opacity: 0.8;
        "
        class="px-4"
      >
        <v-alert
          v-model="tipVisible"
          dismissible
          border="right"
          height="100%"
          colored-border
          type="error"
          elevation="4"
        >
          <v-row dense class="caption">
            <v-col cols="12">尊敬的老师您好：</v-col>
            <v-col cols="12">您当前正在浏览的是项目“{{htbh}}+{{projectInfo.xmmc}}”的结题报告。</v-col>
            <!-- <v-col cols="12">点击“确认无误”后，可下载报告。</v-col> -->
            <v-col cols="12">温馨提示：结题报告仅是部分结果的展示，为了维护您的权益，保障数据交付准确无误，需要您点击下方按钮进行结算确认。在款项充足的条件下，我司将在结算确认后安排完整报告，交互分析（仅限动态交互类）和原始数据的释放，且此后项目进入售后阶段。</v-col>
            <v-col cols="auto" class="pt-2">
              <v-btn large color="primary" @click="onConfirm">结算确认</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </div>
      <v-btn
        @click="tipVisible = true"
        v-if="!tipVisible"
        icon
        fab
        dark
        color="error"
        right
        fixed
        style="top: 10px; opacity: 0.85; z-index: 99"
      >
        <v-icon large>mdi-information</v-icon>
      </v-btn>
    </template>
    <!-- 下载pdf报告 -->
    <template v-if="cf && !bigLoading">
      <v-btn
        @click="onDownloadPdf"
        fab
        dark
        color="primary"
        right
        fixed
        style="bottom: 90px; opacity: 0.85"
        title="下载预览报告"
      >
        <v-icon large>mdi-download</v-icon>
      </v-btn>
    </template>

    <!-- 结算确认弹出框 --> 
    <confirm v-model="showConfirm" :data="projectInfo" v-on="$listeners" />
  </v-container>
</template>
<script>
import {
  userFileStreamReportPdf,
  // userProjectConfirm,
  asgLtcProjectDetail,
  userFileStream,
} from "@/plugins/api";
import confirm from "../confirm.vue";
export default {
  components: { confirm },
  data() {
    return {
      xmh: null,
      xmfah: null,
      htbh: null,
      projectInfo: {},
      pdfImages: [],
      bigLoading: true,
      bigLoadingTimer: 0,
      tipVisible: true,
      showConfirm: false,
    };
  },
  computed: {
    cf() {
      return this.projectInfo.cf;
    },
    // 判断是否管理端
    isManage() {
      const query = this.$route.query;
      return query.endType === "manage" ? true : false;
    },
    // 判断是否预览版报告
    isPreviewReport() {
      const query = this.$route.query;
      return query.preview === "1" ? true : false;
    },
  },
  async mounted() {
    this.xmfah = this.$route.query.xmfah;
    this.htbh = this.$route.query.htbh;
    this.xmh = this.$route.query.xmh;
    this.preview = this.$route.query.preview;
    this.internalReview = this.$route.query.endType === "manage" ? true : false;
    const params = {
      projectNo: this.xmfah,
    };
    await asgLtcProjectDetail(params).then(
      (res) => (this.projectInfo = res.data)
    );

    if(!this.internalReview && !this.preview){ //非内部审核预览，非客户预览结题报告
      if(this.projectInfo.previewFlag) {//有结题报告的项目
        if(this.projectInfo.cf == 0 || this.projectInfo.zt < 2) {
          //如果项目为确认或zt < 2，不能预览正式报告
          return;
        }
      } else {//无结题报告的项目
        if(this.projectInfo.zt < 2) {
          //如果项目zt < 2，不能预览正式报告
          return;
        }
      }  
    }
    // await userProjectDetail(this.xmfah, this.htbh).then(res => this.projectInfo = res.data)
    let dto = { path: `/rep/${this.xmh}/report.pdf` };
    if(this.preview && this.preview == 1) {//预览结题报告
      dto = { path: `/rep/${this.xmh}/summary_report.pdf` };
    }
    this.bigLoadingTimer = 0;
    let bigLoadingTimerCounter = setInterval(
      () => this.bigLoadingTimer++,
      1000
    );
    userFileStreamReportPdf(dto, false)
      .then((res) => {
        this.pdfImages = res.data;
      })
      .finally(() => {
        this.bigLoading = false;
        clearInterval(bigLoadingTimerCounter);
        bigLoadingTimerCounter = undefined;
      });
  },
  methods: {
    onConfirm() {
      // userProjectConfirm(
      //   this.projectInfo.id,
      //   this.projectInfo.xmfah,
      //   this.projectInfo.htbh
      // ).then(() => {
      //   this.$message.success("报告确认完成,3秒后页面自动重新加载");
      //   setTimeout(() => location.reload(), 3000);
      // });
      this.showConfirm=true;
      this.tipVisible=false;
    },
    onDownloadPdf() {
      let dto = { path: `/rep/${this.xmh}/report.pdf` };
      userFileStream(dto, true);
    },
  },
};
</script>
